export type ProviderBootstrapAction = {
  type: string;
  method: string;
  path: string;
  statusQueryParam?: string;
  successStatusValue?: string;
  errorStatusValue?: string;
};

const genericOAuthStartPath = '/integrations/oauth/start';

export const buildProviderBootstrapRequest = (
  action: ProviderBootstrapAction,
  providerKey: string,
  headers: Record<string, string>
): RequestInit => {
  const method = action.method.trim().toUpperCase();
  const isGenericOAuthStart =
    action.type === 'oauth_start' && method === 'POST' && action.path.trim() === genericOAuthStartPath;

  const isOAuthContinuation = action.type === 'oauth_continue' && method === 'POST';

  if (isOAuthContinuation) {
    return { method, headers: { ...headers, 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ action: 'continue_oauth' }) };
  }

  if (!isGenericOAuthStart) {
    return { method, headers, credentials: 'include' };
  }

  return {
    method,
    headers: { ...headers, 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ providerKey })
  };
};
